import React from "react";

// reactstrap components
import {
  Button,
  Label,
  FormGroup,
  Input,
  NavItem,
  InputGroupText,
  InputGroupAddon,
  InputGroup,
  Form,
  Container,
  Row,
  Col
} from "reactstrap";
import Swal from 'sweetalert2';
// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";

import DemoFooter from "components/Footers/DemoFooter.js";

const AboutUs = () => {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add("landing-page");
    return function cleanup() {
      document.body.classList.remove("landing-page");
    };
  });
  const onFormSubmit = (e) => {
    e.preventDefault();
    Swal.fire(
      'Thank you!',
      'Your response has been submitted!',
      'success'
    )
  };

  return (
    <>
      <div className="about-us section" >
        <div
          style={{
            //backgroundImage: "url(" + require("assets/img/bg.png") + ")",
            backgroundColor:"#3E3C3D",
            
          }}
          className="page-bg"
        >
          <ExamplesNavbar notHome={true} />
          {/* <div className="section about-us"> */}
          <Container>
            <Row>
            <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/gate@2x.png") + ")",
                }}
                className="about-image"
              />
              <Col lg={6} >
                <br></br>
                <h3 className="title text-white ">Finest Living  <hr style={{color:"#000000"}}/></h3>
                
                
                <div className="detail text-white">
                
                  Contact us:<br/>
                  +923000247777<br/>
                  +923004714777<br/>
                  <br/>
                  info@merajhousing.com<br/>
                  <br/>
                  Meraj Housing Scheme <br/>
                  Near Daska Sialkot Motorway Interchange Point, Exit No. 5<br/>
                  Daska, Sialkot.



                </div>
              </Col>
              
            </Row>
            <Row>
            
            <Col className="ml-auto mr-auto mt-2" md="12">
              <Form className="contact-form" onSubmit={e => onFormSubmit(e)} style={{backgroundColor:"#3E3C3D"}}>
                <h2 className=" title text-white mb-4">Get in Touch</h2>
                <Row>
                  <Col className="my-2" md="4">
                      <Input placeholder="Name" type="text" required style={{backgroundColor:"#3E3C3D"}}/>
                    </Col>
                  <Col className="my-2" md="4">
                      <Input placeholder="Email (optional)" type="text" required style={{backgroundColor:"#3E3C3D"}}/>
                    
                  </Col>
                  <Col className="my-2" md="4">
                      <Input placeholder="Contact" type="text" required style={{backgroundColor:"#3E3C3D"}}/>
                    </Col>
                </Row>
                <Input
                  placeholder="Message"
                  type="textarea"
                  rows="8"
                  required
                  className="my-2"
                  style={{backgroundColor:"#3E3C3D"}}
                />
                <Row className="justify-content-center">
                 
                  <Button className="" size="md" style={{backgroundColor:"#7b7b7b"}}>
                    Send Message
                    </Button>
                    <Button className="" size="md" style={{backgroundColor:"#7b7b7b"}}>
                    Call +923413265985
                    </Button>
                    
                </Row>
                <br></br>
                <hr style={{width: "1px",height: "100px" ,background: "white", float:"left"}}></hr>
                
              </Form>
            </Col>
          </Row>

            
            
            
          </Container>
          {/* </div> */}
          <div
          className={"footer-logo-section content-center"}style={{backgroundColor:"#000000"}}
        >
          <img
            className="footer-image"
            src={require("assets/img/logo@2x.png")}
          />
          
          
        </div>
         
          { <DemoFooter/> }
        </div>
      </div>
    </>
  );
};

export default AboutUs;
